import { render, staticRenderFns } from "./Transcribe.vue?vue&type=template&id=7161a6b2&scoped=true&"
import script from "./Transcribe.vue?vue&type=script&lang=js&"
export * from "./Transcribe.vue?vue&type=script&lang=js&"
import style0 from "./Transcribe.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Transcribe.vue?vue&type=style&index=1&id=7161a6b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161a6b2",
  null
  
)

export default component.exports